module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_430.e372de06.png";